import React, { Component } from 'react';
import $ from 'jquery';
import axios from "axios";
import { withRouter, getCookie, setCookie, setSearchCookie, setAutoCookie } from './Common';
import { useLocation } from 'react-router-dom';

class SecSearchModal extends Component {

  constructor(props) {
    super(props);
    const stored = getCookie('searchHistory') || [];
    this.state = {
      keyword: '',
      searchHistory: stored,
      todayWord: '',
      dataList: [],     // 배열 데이터를 담음
      loading: true,
      error: null,
      autoSave: getCookie('pocketAuto')
    };
  } 

  handleChange = (e) => {
    this.setState({ keyword: e.target.value });
  }

  handleClick = (e) => {
    e.preventDefault(); // a 태그의 기본 동작 막기
    const navBtn = $(".header .search-btn")
      , navLayer = $(".search-layer")
      , navDimmed = $(".layer-dimmed")
      , navSearchLayerInput = $("#searchLayerInput");

    navBtn.find("span").text("검색창 열기");
    $("html").css("overflow", "auto");
    navBtn.removeClass("active");
    navLayer.removeClass("active");
    navDimmed.stop().hide();
    navSearchLayerInput.val("").blur();

    const { keyword } = this.state;
    const trimmedKeyword = keyword.trim(); // 앞뒤 공백 제거

    if (!trimmedKeyword || trimmedKeyword == '') {
      alert("검색어를 입력해주세요.");
      return; // 아무 것도 하지 않음
    }
    const input = document.getElementById('searchLayerInput'); // input에 id 부여 필요
    input.blur(); // 모바일 키보드 닫힘
    const pocketAuto = getCookie('pocketAuto');
    if (pocketAuto === 'on') {
      this.addSearchHistory(trimmedKeyword);
    }
    this.props.navigate(`/Search/${encodeURIComponent(trimmedKeyword)}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  addSearchHistory = (keyword) => {
    if (this.state.autoSave == 'on') {
      this.setState((prevState) => {
        const updated = [keyword, ...prevState.searchHistory.filter(k => k !== keyword)].slice(0, 10);
        setSearchCookie('searchHistory', updated, { path: '/' });
        return { searchHistory: updated };
      });
    }
  };
  searchRecomKeyword = (e, keyword) => {
    e.preventDefault(); // a 태그의 기본 동작 막기
    const navBtn = $(".header .search-btn")
      , navLayer = $(".search-layer")
      , navDimmed = $(".layer-dimmed")
      , navSearchLayerInput = $("#searchLayerInput");

    navBtn.find("span").text("검색창 열기");
    $("html").css("overflow", "auto");
    navBtn.removeClass("active");
    navLayer.removeClass("active");
    navDimmed.stop().hide();
    navSearchLayerInput.val("").blur();
    const pocketAuto = getCookie('pocketAuto');
    if (pocketAuto === 'on') {
      this.setState((prevState) => {
        const updated = [keyword, ...prevState.searchHistory.filter(k => k !== keyword)].slice(0, 10);
        setSearchCookie('searchHistory', updated, { path: '/' });
      });
    }
    this.props.navigate(`/Search/${encodeURIComponent(keyword)}`);
  };

  async componentDidMount() {
    
    const path = this.props.location.pathname;
    const isHiddenSearchBtn = (path.startsWith("/Search") || path.startsWith("/WordList"));
    if (!isHiddenSearchBtn) {
      const publicUrl = process.env.PUBLIC_URL;
      try {
        const response = await axios.get(publicUrl + '/api/getRecomWord.php');
        const wordRes = await axios.get(publicUrl + '/api/getTodayWord.php');

        this.setState({
          dataList: response.data,  // 예: [{id:1, title:'a'}, {id:2, title:'b'}]
          todayWord: wordRes.data,
          loading: false
        });
      } catch (error) {
        this.setState({
          error: error.message,
          loading: false
        });
        console.log('data error:' + error);
      };

      const pocketAuto = getCookie('pocketAuto');
      if (pocketAuto === undefined || pocketAuto === null || pocketAuto === 'off') {
        this.setState({ autoSave: 'off' });
      }
    }
  }
  componentDidUpdate(prevProps) {
    const path = this.props.location.pathname;
    if (prevProps.pathname !== this.props.pathname && !(path.startsWith("/WordList"))) {
      // 이곳에서 필요한 상태 변경 또는 UI 갱신
      const path = this.props.pathname;
      const segments = path.split('/');
      const lastParam = segments.pop() || segments.pop(); // 마지막 '/' 방지
      const addSearchtxt = decodeURIComponent(lastParam);
      this.addSearchHistory(addSearchtxt);
      this.setState({ keyword: addSearchtxt });
    }
  }
  handleWordClick = (e) => {

    const navBtn = $(".header .search-btn")
      , navLayer = $(".search-layer")
      , navDimmed = $(".layer-dimmed")
      , navSearchLayerInput = $("#searchLayerInput");

    navBtn.find("span").text("검색창 열기");
    $("html").css("overflow", "auto");
    navBtn.removeClass("active");
    navLayer.removeClass("active");
    navDimmed.stop().hide();
    navSearchLayerInput.val("").blur();
    const keyword = this.state.todayWord.title;
    this.props.navigate(`/Search/${encodeURIComponent(keyword)}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  delSearchHistory = (indexToDelete) => {
    const { searchHistory } = this.state;
    const updated = searchHistory.filter((_, i) => i !== indexToDelete);
    setSearchCookie('searchHistory', JSON.stringify(updated), { path: '/' });
    this.setState({ searchHistory: updated });
  };
  handleClearHistory = () => {
    document.cookie = "searchHistory=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    this.setState({ searchHistory: [] });
  };
  changePocketAuto = (val) => {
    if (val == 'on') {
      // 끄기
      this.setState({ autoSave: 'off' });
      setAutoCookie('off');
    } else {
      // 켜기
      this.setState({ autoSave: 'on' });
      setAutoCookie('on');
    }
  }
  //
  render() {
    const { searchHistory, dataList, todayWord, loading, error } = this.state;

    return (
      <aside className="search-layer">
        <div className="search-layer__wrap">
          <div className="container">
            <div className="main-search">
              <form className="main-search__form" method="post" autoComplete="off">
                <button type="submit" className="main-search__btn" title="검색" onClick={this.handleClick}> </button>
                <div className="input-wrap">
                  <input type="search" ref={this.inputRef} className="search-input" id="searchLayerInput" placeholder="궁금한 용어를 검색해 보세요!" value={this.state.keyword} onChange={this.handleChange} />
                </div>
                <button className="search-input__del" type="button" title="내용 삭제"> </button>
              </form>
            </div>
          </div>
          <div className="search-layer__section search-layer__recommend">
            <div className="title-bx">
              <h2 className="tit">추천 검색어</h2>
            </div>
            <></>
            <div className="container">
              <div className="recommend-word-list swiper-container">
                <div className="swiper-wrapper">
                  {dataList.map((item, index) => (
                    <div className="swiper-slide" key={index}><a className="word"
                      href={item ? `/Search/${item.t_term}` : '#'}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (this.isDragging) return; // 스와이프 중이면 무시
                        this.searchRecomKeyword(e, item.t_term)
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      }}># {item.t_term}</a></div>
                  ))}
                </div>
                <div className="swiper-scrollbar"></div>
              </div>
            </div>
          </div>

          <div className="search-layer__section search-layer__recent">
            <div className="title-bx d-flex">
              <h2 className="tit">최근 검색 내역</h2>
              <button type="button" id="del-all" className="btn-del" onClick={() => this.handleClearHistory()}>전체 삭제 <i></i></button>
            </div>
            <div className="container">
              {(searchHistory && searchHistory.length > 0) ? (
                <ul className="recent-search-list">
                  {searchHistory.map((item, idx) => (
                    <li className="recent-search-word" key={idx}>
                      <a href={item ? `/Search/${item}` : '#'} className="word" onClick={(e) => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>{item}</a>
                      <button type="button" className="del" onClick={() => this.delSearchHistory(idx)}></button>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="recent-search-blank">
                  <p className="title">
                    최근 검색내역이 없습니다<br />
                    <em onClick={() => this.handleWordClick()}>'{todayWord?.title}'</em> 은/는 어떠세요?
                  </p>
                  <p class="desc">
                    검색어가 정상 표출되지 않는다면 <br />
                    아래 자동 저장 켜기를 눌러주세요.
                  </p>
                </div>
              )}


              <input className="sr-only" type="checkbox" title="자동 저장" defaultChecked id="btn-save-toggle" />
              <button type="button" className="btn-save-toggle" onClick={() => this.changePocketAuto(this.state.autoSave)} >
                자동 저장 {this.state.autoSave === 'on' ? '끄기' : '켜기'}
              </button>
            </div>
          </div>
        </div>
      </aside>

    );
  }
}

export default withRouter(SecSearchModal);